var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container--employee employee-orders mb-4 employee-orders-catalog"},[_c('BackToAuctionsCatalogsLink',{attrs:{"routeName":'employeesFinishedAuctionsCatalogs'}}),_vm._v(" "),(_vm.isInternetType)?_c('InternetAuctionsCatalogHeader'):_c('AuctionsCatalogHeader'),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-316d31d6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/employees/components/finished/auctions_catalog.vue
// module id = 870
// module chunks = 0 1 2 3 4 5 6 7 8 10 131